'use strict'

import Slider from './Slider'
import ApplyClass from '../../Utils/ApplyClass'

/**
 * @classname CurrentViewedJob
 * @classdesc 最近見た求人
 */
export default class CurrentViewedJob {
	/**
	 * @constructor
	 * @param {jQuery} $e - .swiper-viewed-jobs
	 * @param {instance} controller - controller instance
	 */
	constructor($e, controller) {
		console.log(`${this.constructor.name}.constructor`)
		this._$e = $e
		this._controller = controller

		let localStorageJobData = localStorage.getItem('viewed_jobs') ?? '[]'

		const jobId = $('.section--job-detail.main .text--job-no').text()

		let jobs = JSON.parse(localStorageJobData)
		console.log(jobs)
		if (jobs.length === 0) {
			$('.swiper-viewed-jobs').closest('.block--job-detail-inner').remove()
			console.log('最近見た求人は0件です')
			return
		}
		// async/awaitを使うために即時関数を使っている。新しいメソッドにした方がいいかも
		(async () => {
			const tempJobCardElements = await Promise.all(
				// ループの1つ1つの処理を待つためにmapのコールバック関数をasync functionにする
				// ここでPromiseオブジェクトの配列ができるのでPromise.allでまとめて解決
				jobs.map(async (job) => {
					if (job.id === jobId) return
					console.log(`最近見た求人一覧のurl::/job/${job.id}`)
					// isUrlExistはasync functionなのでawaitをつけるなどしないと完了を待たずに次の処理に行ってしまう
					const isJobExist = await this.isUrlExist(`/job/${job.id}`)
					if (!isJobExist) return
					return this.createJobCard(job)
				}),
			)
			const jobCardElements = tempJobCardElements.filter(Boolean)
			console.log('jobCardElements', jobCardElements)
			$('.swiper-viewed-jobs .swiper-wrapper').append(jobCardElements.join(''))

			if (jobCardElements.length === 0) {
				$('.swiper-viewed-jobs').closest('.block--job-detail-inner').remove()
			}

			ApplyClass.apply(Slider, $e, [$e, this._controller])
		})()
	}

	/**
	 * 求人の描画
	 *
	 * @memberof createJobCard
	 * @param {json} job - 求人データ
	 * @return undefined
	 */
	createJobCard(job) {
		console.log(`${this.constructor.name}.createJobCard`)

		const card = `<li class="swiper-slide list-item">
	<a class="anchor" href="/job/${job.id}">
		<div class="image-box image-box--thumbnail"><img class="image" src="${job.photoUrl}" alt="最近見た求人" loading="lazy" width="1416" height="875">
		</div>
	</a>
	<a class="anchor anchor--job-title" href="/job/${job.id}">${job.title}</a>
	<ul class="list list--detail">
		<li class="list-item">
			<div class="image-box image-box--icon"><img class="image" src="/img/icon/map.webp" alt="ピンクの位置情報"></div>
			<p class="text">${job.location}</p>
		</li>
		<li class="list-item">
			<div class="image-box image-box--icon"><img class="image" src="/img/icon/calendar.webp" alt="ピンクのカレンダー"></div>
			<p class="text">${job.period}</p>
		</li>
		<li class="list-item">
			<div class="image-box image-box--icon"><img class="image" src="/img/icon/occupation.webp" alt="ピンクの人物"></div>
			<p class="text">${job.occupation}</p>
		</li>
		<li class="list-item">
			<div class="image-box image-box--icon"><img class="image" src="/img/icon/money.webp" alt="ピンクの通貨マーク"></div>
			<p class="text">${job.salary}</p>
			<p class="text text--jobType">${job.jobType}</p>
		</li>
	</ul>
</li>`
		return card
	}

	/**
	 * 求人が存在するか判定
	 *
	 * @memberof CurrentViewedJob
	 * @param {json} job - 求人データ
	 * @return boolean
	 */
	async isUrlExist(url) {
		// asyncを付けた関数は関数自体が問答無用で非同期処理となる。返り値の有無にかかわらず返り値がPromiseになる
		console.log(`${this.constructor.name}.isUrlExist`)
		try {
			const res = await fetch(url, { method: 'HEAD' }) // ここで非同期通信が発生
			if (res.ok) {
				console.log('URL exists:', url)
				return true
			}
			if (res.status === 404) {
				console.log('URL not found:', url)
				return false
			}
			console.log(res)
			throw new Error('fetch failed', url)
		} catch (error) {
			console.error(error)
			return false
		}
	}
}
